import { environment } from "../../environments/environment";
import { CookieService } from 'ngx-cookie-service';
import { CacheKey } from "../shared/constants/cachekey.constants";

export class SSO {
    public static SSO_Client_ID = environment.ssoClientID || 'account-test';
    public static SSO_Login_Redirect_URL = window.location.origin + '/login';
    public static SSO_Login_Response_Type = 'code';
    public static SSO_Login_Nonce = 'FLPITITAN';
    public static SSO_Client_ASSERTION = environment.ssoClientAssertion;
    public static ENCRYPTION_KEY = 'j1wootxJBEgAUJHyQ2XDbQ==';

    public static INTERNAL_ACCESS_TOKEN = environment.removeObsoleteCookies === true ? "appadmin." + environment.accessToken : environment.accessToken;
    public static INTERNAL_REFRESH_TOKEN = environment.removeObsoleteCookies === true ? "appadmin." + environment.refreshToken : environment.refreshToken;
    public static INTERNAL_NONCE = environment.idNonce;
    public static AuthorizedUser_UAT = "AuthorizedUser_"+ environment.envName;
    

    public static EXTERNAL_ACCESS_TOKEN = environment.externalAccessToken;
    public static EXTERNAL_REFRESH_TOKEN = environment.externalRefreshToken;
    public static EXTERNAL_NONCE = environment.externalIdNonce;
   
    public static INTERNAL_MEMBER_SESSIONID = CacheKey.InternalMemberSessionGuid + '_' + environment.envName;
    public static IS_NEW_TOKEN = "appadmin.isNewToken";
    public static LOCAL_MEMBER_SESSION_ID = "appadmin.memberSessionId";
    public static EXTERNAL_MEMBER_SESSIONID = CacheKey.ExternalMemberSessionGuid + '_' + environment.envName;

    public static TITAN_EXTERNAL = 'Titan-External';
    public static cookieService: CookieService = new CookieService(document);
    public static getSSOLoginUrl(): string {
        //langCode = langCode ? langCode : 'en';
        this.cookieService.set(SSO.INTERNAL_NONCE, this.getnonce(), null, environment.cookiePath, environment.cookieDomain);
        var state = this.getnonce();
        localStorage.setItem("state", JSON.stringify(state));
        return environment.ssoApiURL + "/auth?client_id=" + environment.ssoClientID + "&redirect_uri=" + this.SSO_Login_Redirect_URL + "&response_type=" + this.SSO_Login_Response_Type + "&state=" + state + "&kc_locale=" + "en";
    }

    public static getSSOLogoutUrl(redirectUri?: string): string {
        return environment.ssoApiURL + "/logout?client_id=" + environment.ssoClientID + "&redirect_uri=" + (redirectUri || window.location.origin);
    }

    public static getnonce(): string {
        var d = new Date().getTime();

        if (window.performance && typeof window.performance.now === "function") {
            d += performance.now();
        }

        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });

        return uuid;
    }

    public static isRemoveObsoleteCookie(): boolean {
        return environment.removeObsoleteCookies;
    }
}  


// WEBPACK FOOTER //
// ./src/app/sso/sso.constants.ts